import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=f090bb56&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"
import style0 from "./Default.vue?vue&type=style&index=0&id=f090bb56&lang=scss&scoped=true&"
import style1 from "./Default.vue?vue&type=style&index=1&id=f090bb56&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f090bb56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f090bb56')) {
      api.createRecord('f090bb56', component.options)
    } else {
      api.reload('f090bb56', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=f090bb56&scoped=true&", function () {
      api.rerender('f090bb56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Default.vue"
export default component.exports